import {
    ContactFormInterface,
    CreateContactRequest,
    CreateUserRequest,
} from '@/modules/contacts/shared/domain/contact-form.interface';
import { Customer } from '@/modules/customers/domain/customer';
import {
    ContactManagementType,
    ContactStatus,
} from '@/modules/shared/shared/domain/constants/constants';
import { Status } from '@/modules/shared/shared/domain/status.interface';

export function transformRolToCreate(customerId: number, privileges: { privilege: number }[]) {
    let rol: {
        name: string;
        description: string;
        customerId: number;
        rolesPrivileges: {
            privilege: number;
        }[];
    } = {
        name: '',
        description: '',
        customerId: -1,
        rolesPrivileges: [],
    };

    rol.name = 'D';
    rol.description = 'Default role';
    rol.customerId = customerId;

    rol.rolesPrivileges = [...privileges];

    return rol;
}

export function transformRolToUpdate(currentRol, privileges) {
    let rol: {
        id: number;
        name: string;
        description: string;
        privileges: {
            privilege: {
                id: number;
            };
        }[];
    } = {
        id: -1,
        name: '',
        description: '',
        privileges: [],
    };

    rol.id = currentRol.id;
    rol.name = currentRol.name;
    rol.description = currentRol.description;
    rol.privileges = [...privileges];

    return rol;
}

export function transformContactToCreate(
    contact: ContactFormInterface,
    customer: Customer,
    statuses: Status[],
    roleCreated: { customerRole: { id: number } },
): CreateContactRequest {
    return {
        password: contact.password,
        name: contact.name,
        lastName: contact.lastName,
        ci: contact.nationality + contact.ci,
        position: contact.position,
        email: contact.email,
        phone: contact.phone,
        cellphone: contact.cellphone,
        userStatus: statuses.find(i => i.name === ContactStatus.PENDING)!.id,
        customerId: customer.id,
        customerName: customer.name,
        contactRoles: [roleCreated.customerRole],
        contactManagementType: ContactManagementType.CREATE,
        contactType: contact.contactType,
        scalabilityLevel: contact.scalabilityLevel,
    };
}

export function transformContactToUpdate(
    contact: ContactFormInterface,
    customer: Customer,
): CreateContactRequest {
    return {
        contactId: contact.contactId,
        userId: contact.userId,
        name: contact.name,
        lastName: contact.lastName,
        ci: contact.nationality + contact.ci,
        position: contact.position,
        email: contact.email,
        phone: contact.phone,
        cellphone: contact.cellphone,
        userStatus: contact.userStatus.id,
        customerId: customer.id,
        customerName: customer.name,
        contactRoles: [contact.contactRoles] as any,
        contactType: contact.contactType,
        scalabilityLevel: contact.scalabilityLevel,
        priority: contact.priority,
        contactManagementType: ContactManagementType.UPDATE,
    };
}

export function transformContactToUpdateAndCreateUser(
    contact: ContactFormInterface,
    customer: Customer,
    statuses: Status[],
    roleCreated: { customerRole: { id: number } },
): CreateUserRequest {
    return {
        contactId: contact.contactId,
        password: contact.password,
        name: contact.name,
        lastName: contact.lastName,
        ci: contact.nationality + contact.ci,
        position: contact.position,
        email: contact.email,
        phone: contact.phone,
        cellphone: contact.cellphone,
        userStatus: statuses.find(i => i.name === ContactStatus.PENDING)!.id,
        customerId: customer.id,
        customerName: customer.name,
        priority: contact.priority,
        customerRole: [roleCreated.customerRole],
        contactType: contact.contactType,
        scalabilityLevel: contact.scalabilityLevel,
        contactManagementType: ContactManagementType.CREATE_USER,
    };
}
